module.exports = __webpack_public_path__ + "h5/img/service_02.da0338d6.jpg";